import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "config/api.config";
import {
  ManagementStudyDates,
  SaveStudyDatesParams,
} from "types/datesManagement.types";
import { ValidationErrors } from "types/masterdata.types";

export const datesManagementApi = createApi({
  reducerPath: "datesManagement",
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    getManagementStudyDates: builder.query<ManagementStudyDates[], void>({
      query: () => ({
        url: "Management/StudyDates",
      }),
    }),
    saveStudyDates: builder.mutation<
      ValidationErrors,
      SaveStudyDatesParams[] | undefined
    >({
      query: (requestBody) => ({
        method: "POST",
        url: "Management/SaveStudyDates",
        body: requestBody,
      }),
    }),
  }),
});

export const { useGetManagementStudyDatesQuery, useSaveStudyDatesMutation } =
  datesManagementApi;
